import { render } from "./PerformanceFinanciere.vue?vue&type=template&id=b7681f6a"
import script from "./PerformanceFinanciere.vue?vue&type=script&lang=js"
export * from "./PerformanceFinanciere.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__